import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import Stepper from "@material-ui/core/Stepper";
import { Step, StepLabel } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
// import { withGTM } from "react-tag-manager";
import process3kycImage from "../../../img/process-3-kyc.png";

const styles = theme => ({
  root: {
    width: "99%"
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  process3kycImage: {
    textAlign: "center"
  }
});

function getSteps() {
  return [
    "Registration",
    "Email Verification",
    "Identity Verification",
    "Wallet Whitelisting"
  ];
}

function getStepContent(stepIndex, UserState) {
  switch (stepIndex) {
    case 0:
      return <Typography>'Registration...'</Typography>;
    case 1:
      return (
        <React.Fragment>
          <Typography variant="h4" align="center">
            Please click on the verification link in the email you´ve just
            received.
            <br />
            <i
              className="material-icons"
              style={{ fontSize: "3em", color: "grey" }}
            >
              email
            </i>{" "}
          </Typography>
          <Typography align="center">
            Didn't receive any email? Please check your spam folder!
          </Typography>
          <Typography align="center">
            We will not send any email if you apply for a second time.
          </Typography>
        </React.Fragment>
      );
    case 2:
      switch (UserState) {
        case "kycDECLINED":
          return (
            <React.Fragment>
              <div align="center">
                <img src={process3kycImage} alt="man" />
              </div>
              <Typography variant="h4" align="center">
                Identity Verification failed!
              </Typography>
              <Typography align="center">
                Thank you for your application! Unfortunately, your account
                cannot be approved.
                <br />
              </Typography>
              <Typography align="center">
                Common reasons for rejection include: expired ID, blurry photos
                or missing selfies. <br />
                Please double-check the information you submitted to ensure that
                it matches your passport exactly.
              </Typography>
              <Typography align="center">
                If you need any further support, please email{" "}
                <a href="mailto:team@crwdnetwork.c">team@crwdnetwork.com</a>.
              </Typography>
            </React.Fragment>
          );
        case "emailVerified":
        case "kycREVIEW":
        default:
          return (
            <React.Fragment>
              <div align="center">
                <img src={process3kycImage} alt="man" />
              </div>
              <Typography variant="h4" align="center">
                Thank you for verifying your email
              </Typography>
              <Typography align="center">
                Your application is under review, and you should receive a
                response within 1 business day (Please check your spam folder).
              </Typography>
              <Typography align="center">
                Once your application is approved, you will receive an email
                with further instructions. Thank you for your interest in
                joining the CRWD Network!
              </Typography>
              <Typography align="center">
                If you need any further support, please email{" "}
                <a href="mailto:team@crwdnetwork.com">team@crwdnetwork.com</a>.
              </Typography>
            </React.Fragment>
          );
      }
    case 3:
      return (
        <React.Fragment>
          <Typography variant="h4" align="center">
            Your application is approved
          </Typography>
          <Typography align="center">
            We are processing your ERC20 Wallet. You should receive a response
            within 1 business day (Please check your spam folder).
          </Typography>
          <Typography align="center">
            Thank you for your interest in joining the CRWD Network!
          </Typography>
          <Typography align="center">
            If you need any further support, please email{" "}
            <a href="mailto:team@crwdnetwork.com">team@crwdnetwork.com</a>.
          </Typography>
        </React.Fragment>
      );
    case 4:
      return (
        <React.Fragment>
          <Typography variant="h4" align="center">
            Whitelisting succeded
          </Typography>
          <Typography align="center">
            We will notify you per email when Crowd-Sale starts.
          </Typography>
        </React.Fragment>
      );
    default:
      return <Typography>'Unknown stepIndex'</Typography>;
  }
}

class ProcessState extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: this.props.step
    };
  }
  componentDidMount() {
    // const { GTM } = this.props;
    // const path = [
    //   "/i/dashboard/registration",
    //   "/i/dashboard/emailverification",
    //   "/i/dashboard/identityverification",
    //   "/i/dashboard/walletwhitelisting",
    //   "/i/dashboard/paymentinformation"
    // ];
    // GTM.api.trigger({
    //   event: "pageViewProcess",
    //   path: path[this.props.step]
    // });
  }

  //   handleNext = () => {
  //     const { activeStep } = this.state;
  //     this.setState({
  //       activeStep: activeStep + 1,
  //     });
  //   };

  //   handleBack = () => {
  //     const { activeStep } = this.state;
  //     this.setState({
  //       activeStep: activeStep - 1,
  //     });
  //   };

  //   handleReset = () => {
  //     this.setState({
  //       activeStep: 0,
  //     });
  //   };

  render() {
    const { classes, userstatus } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;

    return (
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(label => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div className={classes.instructions}>
          {getStepContent(activeStep, userstatus)}
        </div>
      </div>
    );
  }
}

ProcessState.propTypes = {
  classes: PropTypes.object
};

// const gtmProcessState = withGTM(ProcessState);
const gtmProcessState = ProcessState;

export default withStyles(styles)(gtmProcessState);
